import React from 'react';
import { Link } from "react-router-dom";

import Banner from '../../components/Banner';
import Breadcrumb from '../../components/Breadcrumb';
import { motion } from 'framer-motion';
import SEO from '../../components/SEO';
import '../../styles/pages/WhyChooseUs.css';

import ServicesSection from "../../components/ServicesSection";
import Newsection from "../../components/Newsection";
import Testimonials from "../../components/Testimonials";
import WhyBg from '../../images/why-bg.jpg'

const WhyChooseUs = () => {

    const container = (delay = 0) => ({
        hidden: {},
        show: {
            transition: {
                delayChildren: delay,
                staggerChildren: STAGGER
            }
        }
    });

    const STAGGER = 0.045;   // typing speed per character
    const START_DELAY = 0.6; // delay before typing begins

    /* left image */
    const imageAnim = {
        hidden: { opacity: 0, x: -80, scale: 0.95 },
        show: {
            opacity: 1,
            x: 0,
            scale: 1,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    /* right content */
    const contentAnim = {
        hidden: { opacity: 0, x: 80 },
        show: {
            opacity: 1,
            x: 0,
            transition: { duration: 0.8, ease: "easeOut" }
        }
    };

    const itemAnim = {
        hidden: { opacity: 0, y: 20 },
        show: { opacity: 1, y: 0, transition: { duration: 0.5 } }
    };

    /* progress bar animation */
    const progressAnim = (value) => ({
        hidden: { width: 0 },
        show: {
            width: value,
            transition: { duration: 1.4, ease: "easeOut" }
        }
    });


    return (
        <motion.div
        className='why-main'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >
            <SEO title="Why Choose Us" description="Reasons to choose Fortune Cloud Solutions." />
            <Banner title="WHY CHOOSE US" image={WhyBg} />
            <div className="">
                <Breadcrumb />
                <ServicesSection />
                {/* <Testimonials /> */}
            </div>
        </motion.div>
    );
};

export default WhyChooseUs;
